import { render, staticRenderFns } from "./ForumEventSession.vue?vue&type=template&id=6c81b01b&scoped=true"
import script from "./ForumEventSession.vue?vue&type=script&lang=js"
export * from "./ForumEventSession.vue?vue&type=script&lang=js"
import style0 from "./ForumEventSession.vue?vue&type=style&index=0&id=6c81b01b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c81b01b",
  null
  
)

export default component.exports